<template>
    <div class="benefit-item" :class="benefit.mobile_style">
        <NuxtImg
            v-if="benefit.icon?.filename"
            :src="benefit.icon.filename"
            :title="benefit.icon.title"
            :alt="benefit.icon.alt"
            provider="storyblok"
            format="webp"
            loading="lazy"
            :class="{
                'icon-large': benefit.icon_size !== 'small',
                'icon-small': benefit.icon_size === 'small',
            }"
            densities="x1"
        />
        <div v-if="benefit.title" class="title" :style="titleStyles">
            {{ benefit.title }}
        </div>
        <p v-if="benefit.text" class="content" v-html="benefit.text"></p>
    </div>
</template>

<script lang="ts" setup>
import type { ITextTitleIcon } from '@nuxt-monorepo/ui/types/components/TextTitleIcon';

const benefit = defineProps<ITextTitleIcon>();
const titleStyles = computed(() => ({
    'font-weight': benefit.title_font_weight ? benefit.title_font_weight : null,
    color: benefit.title_color?.color ? benefit.title_color?.color : null,
}));
</script>

<style lang="postcss" scoped>
.benefit-item {
    @apply min-h-[225px];
    .icon-small,
    .icon-large {
        @apply min-h-[100px];
    }
}
</style>
